import { defineLanguage } from "../registry";

const PAIRS = [
  { open: "{", close: "}" },
  { open: "[", close: "]" },
  { open: "(", close: ")" },
  { open: "[|", close: "|]" },
  { open: "{|", close: "|}", notIn: ["string", "comment"] },
  { open: '"', close: '"', notIn: ["string", "comment"] },
  { open: "(*", close: " *)", notIn: ["string", "comment"] },
];

// ocamlformat's defaults: 2 spaces. Not ' (type variables like 'a) among the auto-closed pairs.
export default defineLanguage({
  id: "ocaml",
  runner: "ocaml",
  config: {
    brackets: [
      ["{", "}"],
      ["[", "]"],
      ["(", ")"],
      ["[|", "|]"],
      ["begin", "end"],
      ["struct", "end"],
      ["sig", "end"],
      ["object", "end"],
      ["do", "done"],
    ],
    autoClosingPairs: PAIRS,
    surroundingPairs: [
      { open: "(", close: ")" },
      { open: "[", close: "]" },
      { open: "{", close: "}" },
      { open: '"', close: '"' },
    ],
    // Indent after a line that opens something (let … =, ->, begin, struct, match … with, …);
    // outdent at the line that closes it.
    indentationRules: {
      increaseIndentPattern:
        /^(?!.*\(\*(?!.*\*\))).*(\b(begin|struct|sig|object|do|then|else|try|with|function|fun\b.*->)|=|->|\(|\[\|?|\{)\s*(\(\*.*\*\))?\s*$/,
      decreaseIndentPattern: /^\s*(end\b|done\b|[)\]}]|\|\])/,
    },
    indent: { size: 2 },
  },
});
